import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { addWebp } from '@digilize/shared/utils/helpers';

@Component({
  selector: 'lib-card-photo',
  templateUrl: './card-photo.component.html',
  styleUrls: ['../card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CardPhotoComponent implements OnInit {
  @Input() img: string;
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  onItemClick() {
    this.itemClicked.emit(this.img);
  }

  get addWebp() {
    return addWebp();
  }
}
